import { render, staticRenderFns } from "./AboutUsDialog.vue?vue&type=template&id=9a0f84d0"
import script from "./AboutUsDialog.vue?vue&type=script&lang=js"
export * from "./AboutUsDialog.vue?vue&type=script&lang=js"
import style0 from "./AboutUsDialog.vue?vue&type=style&index=0&id=9a0f84d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports